export const originalDeviceTypeData = {
  id: '',
  deviceType: '',
  quantity: '',
};

export const originalSpectrumData = {
  spectrumId: '',
  monthlyCost: '',
  installationCost: '',
};

export const underlaySelectionsLocationgroupsData = {
  underlayProductId: '',
  SpectrumPrice: '',
  diyPrice: '',
  quantity: '',
};

export const originalDiyData = {
  diyId: '',
  diyDeviceType: '',
  diyModel: '',
  deviceDescription: '--',
  hardwareCost: '',
  licenseType: '--',
  licenseTerm: '--',
  licenseDescription: '--',
  licensingCost: '',
};

export const tcoFormattedPrice = (price: number | string) => {
  const number = Number(price);

  return isNaN(number)
    ? '0.00'
    : number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
};
